import userSelectors from 'selectors/user';

const isPreIdentifiedUser = function(state) {
  const name = userSelectors.getName(state.user);
  const email = userSelectors.getEmail(state.user);
  const hasUserOnboarded = userSelectors.getHasUserOnboarded(state.user);
  return !!(email && name && !hasUserOnboarded);
};

export default isPreIdentifiedUser;
